// @ts-nocheck
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GetRealEstateList } from '../../store/SU/realEstateSlice';
import { useTranslation } from 'react-i18next';

const useGetRealEstateList = () => {
  const dispatch = useDispatch();

  const {t , i18n} = useTranslation();

  useEffect(() => {
    if (RealEstateList?.length === 0) {
      dispatch(GetRealEstateList());
    }
  }, [dispatch]);

  const { RealEstateList, loading, error } = useSelector(state => state.RealState);

  const OptionsRealEstate = RealEstateList?.map(item => ({
    value: item.id,
    label: i18n.language === 'en' ? item.name : item.name2
  }));

  return { RealEstateList, loading, error, OptionsRealEstate };
};

export default useGetRealEstateList;
